const jsonDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/

const preciseCompactCurrency = new Intl.NumberFormat("en-US", {
	minimumFractionDigits: 0,
	maximumFractionDigits: 1,
	notation: "compact",
	style: "decimal",
})

const roundedCompactCurrency = new Intl.NumberFormat("en-US", {
	minimumFractionDigits: 0,
	maximumFractionDigits: 0,
	notation: "compact",
	style: "decimal",
})

const currency = new Intl.NumberFormat("en-US", {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
	style: "decimal",
})

const integer = new Intl.NumberFormat("en-US", {
	minimumFractionDigits: 0,
	maximumFractionDigits: 0,
	style: "decimal",
})

const precisePercent = new Intl.NumberFormat("en-US", {
	minimumFractionDigits: 0,
	maximumFractionDigits: 1,
	style: "percent",
})

const roundedPercent = new Intl.NumberFormat("en-US", {
	minimumFractionDigits: 0,
	maximumFractionDigits: 0,
	style: "percent",
})

const kilobyte = new Intl.NumberFormat("en-US", {
	minimumFractionDigits: 0,
	maximumFractionDigits: 1,
	style: "unit",
	unit: "kilobyte",
})

const megabyte = new Intl.NumberFormat("en-US", {
	minimumFractionDigits: 0,
	maximumFractionDigits: 1,
	style: "unit",
	unit: "megabyte",
})

const fmt = {
	compactCurrency: function (symbol, cents) {
		if (typeof cents != "number") {
			return ""
		}
		if (cents > 100 * 1e6) {
			return `${symbol}${preciseCompactCurrency.format(cents / 100)}`
		}
		if (cents > 100 * 1e3) {
			return `${symbol}${roundedCompactCurrency.format(cents / 100)}`
		}
		return this.currency(symbol, cents)
	},

	currency: function (symbol, cents) {
		return typeof cents != "number" ? "" : `${symbol}${currency.format(cents / 100)}`
	},

	integer: function (value) {
		return typeof value != "number" ? "" : integer.format(value)
	},

	percent: function (value) {
		if (typeof value != "number") {
			return ""
		}
		if (value < 0.1) {
			return precisePercent.format(value)
		}
		return roundedPercent.format(value)
	},

	bytes: function (bytes) {
		if (typeof bytes != "number") {
			return ""
		}
		if (bytes > 1e6) {
			return megabyte.format(bytes / 1e6)
		}
		return kilobyte.format(bytes / 1e3)
	},

	timestamp: function (value) {
		if (typeof value != "string" || !value.match(jsonDateRegex)) {
			return ""
		}
		const utc = new Date(value)
		const gmt = new Date(utc.getTime() - utc.getTimezoneOffset() * 60 * 1000).toJSON()
		return `${gmt.substring(0, 10)} ${gmt.substring(11, 19)}`
	},
}

module.exports = {fmt}
